const monitorRouter = {
  route: null,
  name: null,
  title: '监测任务',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont el-icon-suitcase-1',
  filePath: 'view/monitor/', // 文件路径
  order: 2,
  inNav: true,
  permission: ['监测任务列表'],
  children: [
    {
      title: '监测任务列表',
      type: 'view',
      name: 'monitorList',
      route: '/monitor/list',
      filePath: 'view/monitor/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-notebook-2',
      permission: ['监测任务列表'],
    },
  ],
}

export default monitorRouter
